import React from 'react';
import ChoroplethCirclePattern from './ChoroplethCirclePattern';
import ChoroplethDashedPattern from './ChoroplethDashedPattern';

export default class ChoroplethPatternDefiner extends React.Component {
  GRAY_COLOR = [191, 191, 191];
  NULL_COLOR = [255, 255, 255];

  constructor(props) {
    super(props);
  };

  patternColor(index) {
    if (index >= 2)
      return this.props.colorBins[0]
    else
      return this.props.colorBins[4]
  }

  backgroundColor(index) {
    return this.props.colorBins[index]
  }

  render() {
    const names = this.props.names;
    const colorBins = this.props.colorBins;
    const strokeColor = this.props.strokeColor;
    return (
      <defs>
        {
          colorBins.map((colorBin, index) => {
            return (
              <ChoroplethCirclePattern key={"pattern-" + index}
                patternDensity={colorBins.length - index}
                patternSize={1.6}
                patternName={names[index]}
                patternColor={this.patternColor(index)}
                backgroundColor={this.backgroundColor(index)} />
            )
          })
        }
        {
          <ChoroplethDashedPattern
            patternSize={4}
            patternDensity={15}
            patternRotation={45}
            patternName="no-data-pattern"
            patternColor={this.GRAY_COLOR}
            backgroundColor={this.NULL_COLOR} />

        }
      </defs>
    );
  };
}
